import TitleResult from "components/common/title-result";
import React, { Fragment } from "react";

const HeaderDesktopFilters = ({
    isMenuActive,
    isClickedBtn,
    totalComposers,
    totalWorks,
    showMobileFilter,
    setShowMobileFilter,
    children
}) => {
    return (

        <div className="w-full flex flex-col justify-between">

            <div className="flex flex-row hidden lg:block">
                <div className="
                    grid 
                    gap-2 
                    md:gap-6
                    sm:grid-cols-2
                    lg:grid-cols-3
                    xl:grid-cols-4
                    2xl:grid-cols-5
                  ">
                    <Fragment>
                        {children}
                    </Fragment>
                </div>
            </div>

            <div className="flex flex-col md:flex-row md:items-center space-y-4 lg:space-y-0 md:justify-between w-full pb-4 border-b pt-5" >
                <TitleResult
                    isMenuActive={isMenuActive}
                    isClickedBtn={isClickedBtn}
                    totalComposers={totalComposers}
                    totalWorks={totalWorks}
                    customClassName=" text-center md:text-left "
                />
                <div className="block lg:hidden flex flex-row items-end w-full">
                    <button className="flex flex-row text-center px-6 py-2 border w-full border-gray-300 border-2 text-gray-600 rounded-lg hover:bg-gray-300" onClick={() => setShowMobileFilter(!showMobileFilter)}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 cursor-pointer mr-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75" />
                        </svg>
                         Open filter here...
                    </button>
                </div>
            </div>
        </div>
    )
}

export default HeaderDesktopFilters;